export const SET_SETTINGS_DATA = "SET_SETTINGS_DATA";

export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";

